<template>
  <IQOS enabled class="gap-row-xs" :title="$t('promocode_types.' + group.promo_type)">
    <template #title>
      <span>
        {{ $t("promocode_types." + group.promo_type) }}
        <template v-if="group.discount"> ({{ group.discount }}%) </template>
      </span>
    </template>

    <div class="stat-row gap-column-xs">
      <div class="stat-row-col">
        <div class="label qrw-label-sm v1-grey-6-color">{{ $t("promocode_group_card.used_count") }}</div>
        <div class="number qrw-label-sm v1-grey-3-color">
          {{ usedCount
          }}<span class="v1-grey-6-color" v-if="!isSinglePromocode">
            / {{ group.promocodes.length }}
          </span>
        </div>
      </div>
      <div class="stat-row-col" v-if="!isSinglePromocode">
        <div class="label qrw-label-sm v1-grey-6-color">{{ $t("promocode_group_card.count_ph") }}</div>
        <div class="number qrw-label-sm v1-grey-3-color">{{ group.promocodes.length }}</div>
      </div>
      <div class="stat-row-col" v-else>
        <div class="label qrw-label-sm v1-grey-6-color">{{ $t("promocode_group_card.code_ph") }}</div>
        <div class="number qrw-label-sm white32-color">{{ group.custom_promocode }}</div>
      </div>
    </div>
    <div class="container-box">
      <BaseButton
        variant="secondary"
        color="v1-grey-3"
        size="md"
        @click="copyPromocode"
        class="w-100"
        v-if="isSinglePromocode"
      >
        {{ $t("promocode_group_card.copy_btn") }}
      </BaseButton>

      <router-link tag="div" :to="`/promocodes/${group._id}`" v-else>
        <BaseButton variant="secondary" size="md" color="v1-grey-3" class="w-100">
          {{ $t("promocode_group_card.view_btn") }}
        </BaseButton>
      </router-link>
    </div>

    <DangerConfirmModal
      @cancel="deleting = false"
      @confirm="onDelete"
      v-if="deleting"
      >{{ $t("promocode_group_card.delete_confirm") }}</DangerConfirmModal
    >
  </IQOS>
</template>

<script>
import PromocodesAPI from "@/api/promocodes";

const copyToClipboard = (str) => {
  const el = document.createElement("textarea");
  el.value = str;
  el.setAttribute("readonly", "");
  el.style.position = "absolute";
  el.style.left = "-9999px";
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
};

export default {
  props: {
    group: Object,
  },
  data() {
    return {
      deleting: false,
    };
  },
  methods: {
    onDelete() {
      PromocodesAPI.remove(this.group._id)
        .then((data) => {
          this.$emit("deleted");

          this.$store.dispatch("auditlog/write", {
            type: "delete_promocode",
            payload: {
              group_id: this.group._id,
              count: this.group.promocodes.length,
            },
          });
        })
        .catch((err) => {
          alert(`${err}`);
        });
    },
    copyPromocode() {
      copyToClipboard(this.group.custom_promocode);
    },
  },
  computed: {
    isSinglePromocode() {
      return this.group.is_custom;
    },
    usedCount() {
      if (this.isSinglePromocode) return this.group.promocodes.length;

      return this.group.promocodes.filter((p) => p.used_at).length;
    },
  },
};
</script>

<style scoped>
.description {
  font-size: 1.6666666666666667vh;
  line-height: 1.8888888888888888vh;
  color: #908f8d;
}
.label {
  font-size: 1.6666666666666667vh;
  line-height: 1.8888888888888888vh;
  color: #908f8d;
  width: 100%;
}

.number {
  font-size: 3.3333333333333335vh;
  line-height: 3.888888888888889vh;
  color: #ededed;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.number span {
  color: #908f8d;
}
.stat-row {
  display: flex;
}
.stat-row .stat-row-col {
  width: 48%;
}
.stat-row .stat-row-col:last-child {
  margin-right: 0;
}
.iqos-transparent .container-box {
  background: transparent;
}
.delete-promocode {
  cursor: pointer;
}
.promocode-iqos-header {
  display: flex;
  justify-content: space-between;
}
</style>